import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class MatPaginatorIntlSrb extends MatPaginatorIntl {
    constructor(private translateService: TranslateService) {
        super();
    
        // kada se prvi put inicijalizuje jezik
        this.translateLabels();
    
        this.translateService.onLangChange.subscribe(() => {
          this.translateLabels();
        });
    }

    translateLabels() {
        this.itemsPerPageLabel = this.translateService.instant('paginator.itemsPerPage');
        this.nextPageLabel = this.translateService.instant('paginator.nextPage');
        this.previousPageLabel = this.translateService.instant('paginator.previousPage');
        this.firstPageLabel = this.translateService.instant('paginator.firstPage');
        this.lastPageLabel = this.translateService.instant('paginator.lastPage');
        this.changes.next();
    }

    getRangeLabel = (page: number, pageSize: number, length: number): string => {
        let of = this.translateService.instant("paginator.of");
    
        if (length == 0) {
          return "0 " + of + " 0";
        }
    
        let startIndex = page * pageSize;
        let endIndex = Math.min(startIndex + pageSize, length);
    
        return startIndex + 1 + " - " + endIndex + " " + of + " " + length;
      };
}